// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Activities/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm_Content_Content_Activities($id: uuid!) {
  tasks_tasks_by_pk(id: $id) {
    id
    created_at
    created_by_user {
      id
      vaxiom_person {
        _id
        first_name
        last_name
      }
    }
  }
  tasks_audit_logs(
    where: {
      task_id: { _eq: $id }
      type: { _nin: [TASK_COMMENT_ADDED, TASK_CREATED] }
    }
  ) {
    id
    type
    task_id
    metadata
    created_at
  }

  tasks_comments(
    where: { task_id: { _eq: $id } }
    order_by: { created_at: desc }
  ) {
    id
    value
    created_at
    created_by_user {
      id
      vaxiom_person {
        _id
        first_name
        last_name
      }
    }
  }
}

`